import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html, body {
    overflow: auto;
    height: 100vh;
    margin: 0;
  }

  p {
    margin: 0;
  }

  /* Global scrollbar – applies to all scroll containers; change once here to update app-wide */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => `${theme.colors.secondaryText} transparent`};
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background-color: ${({ theme }) => theme.colors.secondaryText};
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.background.light};
  }

  /* Use this class when scrollbar should be hidden (e.g. modal content) */
  .scrollbar-hidden {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scrollbar-hidden::-webkit-scrollbar {
    display: none;
  }

  .ReactModal__Overlay.slide-from-right {
    opacity: 1 !important;
    transition: ${({ theme }) => (theme.useAnimations ? 'transform 0.3s ease-in-out' : '')};
    transform: translateX(100%);
  }

  .ReactModal__Overlay--after-open.slide-from-right {
    opacity: 1 !important;
    transform: translateX(0);
  }

  .ReactModal__Overlay--before-close.slide-from-right {
    opacity: 1 !important;
    transform: translateX(100%);
  }

  .ReactModal__Overlay.slide-from-left {
    opacity: 1 !important;
    transition: ${({ theme }) => (theme.useAnimations ? 'transform 0.3s ease-in-out' : '')};
    transform: translateX(-100%);
  }

  .ReactModal__Overlay--after-open.slide-from-left {
    opacity: 1 !important;
    transform: translateX(0);
  }

  .ReactModal__Overlay--before-close.slide-from-left {
    opacity: 1 !important;
    transform: translateX(-100%);
  }
`;
